import Vue from 'vue'

Vue.component('my-header', () => import('@/components/header'))
Vue.component('my-footer', () => import('@/components/footer'))
Vue.component('my-swiper', () => import('@/components/swiper'))
Vue.component('my-pagination', () => import('@/components/pagination'))

// 游戏详情
Vue.component('my-gamedesc', () =>
  import('@/pages/news/game/gamelistinfo/gamedesc')
)



// WEBPACK FOOTER //
// ./src/plugin/components.js